// import footer from "../../assets/footer.svg";
import "./footer.css"

export default function Footer() {
  return (
    <div className="footer">
      {/* <img src={footer} alt="footer" /> */}
    </div>
  );
}
